module.exports = __webpack_public_path__ + "img/product_eSIM.629abb3d.svg";